<template>
  <div class="com-valorant-match-record-card" :class="dataInfo.type">
    <component
      v-if="is_show"
      :is="curCpt"
      :data-info="card_data"
      :match-data="matchData"
    ></component>
    <com-footer @click.native="openMatch">
      <OutOpen
        :protocol="heyboxProtocol"
        :page-identifier="'bbs/link'"
        v-if="canUseDeepLink && articleInfo.source == 'share'"
      ></OutOpen>
    </com-footer>
  </div>
</template>
<script>
import { executeProtocol, executeProtocolOutApp } from '_lib/utils';

import ComMap from './components/com-map.vue';
import ComScore from './components/com-score.vue';
import ComTeam from './components/com-team.vue';
import ComPlayer from './components/com-player.vue';
import comFooter from './components/com-footer.vue';
import { CptMixin } from '../../../mixins/CptMixin';
import { mockCardData } from './mock/mock';
import OutOpen from '_com/OutOpen';
export default {
  mixins: [CptMixin],
  props: {
    canUseDeepLink: {
      type: Boolean,
    },
  },
  components: {
    ComMap,
    ComScore,
    ComTeam,
    ComPlayer,
    comFooter,
    OutOpen,
  },
  data() {
    return {
      card_data: {},
      is_show: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      // TEST
      // this.card_data = mockCardData(this.type)
      let {
        data: { result, status },
      } = await this.dataInfo.request;
      if (status != 'ok') return;
      this.card_data = {
        card_params: this.dataInfo,
        ...result,
      };
      // console.log(result);
      this.is_show = true;
    },
    openMatch() {
      let protocol = {
        protocol_type: 'openWindow',
        full_screen: true,
        mini_program: '1',
        mini_program_id: '24',
        status_bar: {
          style: 'light',
        },
        navigation_bar: {
          title: ' ',
          right_icon: {
            enabled: false,
          },
        },
        webview: {
          url:
            window.$WEB_HOST +
            `/tools/match_center/match_detail?match_id=${this.dataInfo.match_id}`,
          pull: false,
          refresh: false,
        },
      };
      switch (this.articleInfo.source) {
        case 'share': {
          executeProtocolOutApp(protocol);
          break;
        }
        case 'post': {
          executeProtocol(protocol);
          break;
        }
      }
    },
  },
  computed: {
    matchData() {
      return this.card_data?.val_match_data?.[this.dataInfo.val_match_id] || {};
    },
    curCpt() {
      switch (this.dataInfo.type) {
        case 'half_score':
        case 'score_one':
        case 'score_two':
        case 'score_three':
          return 'ComScore';
        case 'map':
          return 'ComMap';
        case 'team':
          return 'ComTeam';
        case 'player':
          return 'ComPlayer';
        default:
          return '';
      }
    },
    heyboxProtocol() {
      let protocol = {
        protocol_type: 'openWindow',
        full_screen: true,
        mini_program: '1',
        mini_program_id: '24',
        status_bar: {
          style: 'light',
        },
        navigation_bar: {
          title: ' ',
          right_icon: {
            enabled: false,
          },
        },
        webview: {
          url:
            window.$WEB_HOST +
            `/tools/match_center/match_detail?match_id=${this.dataInfo.match_id}`,
          pull: false,
          refresh: false,
        },
      };
      return 'heybox://' + encodeURIComponent(JSON.stringify(protocol));
    },
  },
};
</script>

<style lang="less" scoped>
@import '~_style/common.css';

.com-valorant-match-record-card {
  position: relative;
  margin-top: 12px;
  background: #fafbfc;
  border-radius: 8px;
  overflow: hidden;
  &::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    border-radius: 16px;
    border: 1px solid #f3f4f5;
    transform: scale(0.5);
    transform-origin: left top;
    pointer-events: none;
    overflow: hidden;
  }
  &.score_one,
  &.half_score {
    height: 263px;
  }
  &.score_two {
    height: 389px;
  }
  &.score_three {
    height: 526px;
  }
  &.team {
    height: 125px;
  }
  &.map {
    height: 92px;
  }
  &.player {
    height: 550px;
  }
}

/deep/ .center {
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/ .image {
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

/deep/ .hel-font {
  font-family: Helvetica;
}
</style>
